var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import Signals from '../../signals/Signals';
import createServiceSchema from '../../requests/service/createServiceSchema';
/**
 *
 */
var CreateServiceSchemaCommand = /** @class */ (function (_super) {
    __extends(CreateServiceSchemaCommand, _super);
    function CreateServiceSchemaCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param serviceSchema ServiceSchemaModel
     * @param organisation OrganisationModel
     * @param intl
     * @return {*}
     */
    CreateServiceSchemaCommand.prototype.execute = function (serviceSchema, organisation, intl) {
        this.serviceSchema = serviceSchema;
        this.intl = intl;
        var promise = createServiceSchema(serviceSchema, organisation);
        promise.then(this.then);
        return promise;
    };
    /**
     *
     * @param response
     */
    CreateServiceSchemaCommand.prototype.then = function (response) {
        Signals.ShowNotification.dispatch(this.intl.formatMessage({ id: 'notification.service.schema.added' }, Object(this.serviceSchema)), 'dark', true);
    };
    return CreateServiceSchemaCommand;
}(Command));
export default CreateServiceSchemaCommand;
